/* eslint-disable no-underscore-dangle */
import { isFunction, isObject } from 'underscore';

export function isPromise<T = any>(val: any): val is Promise<T> {
  return isObject(val) && isFunction(val.then);
}
